import React from 'react';
import { MessageCircle, Plus, Key, Trash2 } from 'lucide-react';

const Sidebar = ({ 
  isSidebarOpen, 
  conversations, 
  currentConversationId, 
  createNewConversation,
  openApiKeyModal,
  setCurrentConversationId,
  setIsSidebarOpen,
  deleteConversation 
}) => {
  return (
    <>
      {/* サイドバー */}
      <div className={`sidebar ${isSidebarOpen ? 'sidebar-open' : ''}`}>
        <div className="sidebar-content">
          <div className="sidebar-header">
            <button onClick={createNewConversation} className="btn btn-primary btn-block">
              <Plus className="icon-small" />
              新しい会話
            </button>
            
            <button onClick={openApiKeyModal} className="btn btn-secondary btn-block">
              <Key className="icon-xs" />
              APIキー設定
            </button>
          </div>
          
          <div className="conversation-list">
            {conversations.map(conv => (
              <div
                key={conv.id}
                className={`conversation-item ${conv.id === currentConversationId ? 'active' : ''}`}
                onClick={() => {
                  setCurrentConversationId(conv.id);
                  setIsSidebarOpen(false);
                }}
              >
                <MessageCircle className="icon-xs" />
                <span className="conversation-title">
                  {conv.summary || conv.title}
                </span>
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    deleteConversation(conv.id);
                  }}
                  className="delete-btn"
                >
                  <Trash2 className="icon-xs" />
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* モバイル用サイドバーオーバーレイ */}
      {isSidebarOpen && (
        <div className="sidebar-overlay" onClick={() => setIsSidebarOpen(false)} />
      )}
    </>
  );
};

export default Sidebar;